import { offerings, steps, email, emailText, headshot, tagline, belief, about, contact, socials, year } from "./content";
import Switcher from "./Switcher";
import "./horizon.css";

export default function Horizon() {
  return (
    <div className="d2" id="top">
      <a className="d2-skip" href="#main">Skip to content</a>

      <header className="d2-header d2-wrap">
        <a className="d2-brand" href="#top" aria-label="Bit Haiku home">bit haiku</a>
        <nav aria-label="Main navigation">
          <a href="#services">Services</a>
          <a href="#about">About</a>
          <a href="#contact">Let’s talk</a>
        </nav>
      </header>

      <main id="main">
        <section className="d2-hero" aria-labelledby="d2-hero-title">
          <div className="d2-sky">
            <div className="d2-sun" aria-hidden="true" />
            <div className="d2-wrap d2-hero-title">
              <h1 id="d2-hero-title">More business, <em>less busywork.</em></h1>
            </div>
          </div>
          <div className="d2-ground">
            <div className="d2-wrap d2-hero-copy">
              <p className="d2-kicker">Software · AI automation · Security</p>
              <p className="d2-lead">{tagline}</p>
              <a className="d2-cta" href="#contact">Take the first step</a>
            </div>
          </div>
        </section>

        <section className="d2-steps d2-wrap" aria-labelledby="d2-steps-title">
          <h2 id="d2-steps-title" className="d2-kicker">How a project goes</h2>
          <ol>
            {steps.map((step) => (
              <li key={step.id}>
                <span className="d2-step-id">{step.id} — {step.label}</span>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </li>
            ))}
          </ol>
        </section>

        <section className="d2-services" id="services" aria-labelledby="d2-services-title">
          <div className="d2-wrap d2-services-head">
            <p className="d2-kicker">What we do</p>
            <h2 id="d2-services-title">Remove the pain from your <em>processes.</em></h2>
          </div>
          {offerings.map((offering, i) => (
            <article key={offering.id} className={`d2-band ${i % 2 ? "d2-band-alt" : ""}`}>
              <div className="d2-wrap d2-band-inner">
                <span className="d2-band-id">{offering.id}</span>
                <h3>{offering.title}</h3>
                <div>
                  <p>{offering.text}</p>
                  <ul>{offering.items.map((item) => <li key={item}>{item}</li>)}</ul>
                </div>
              </div>
            </article>
          ))}
        </section>

        <section className="d2-belief" aria-labelledby="d2-belief-title">
          <div className="d2-wrap">
            <p className="d2-kicker">How we work</p>
            <h2 id="d2-belief-title"><em>{belief.title}</em></h2>
            <div className="d2-belief-cols">
              {belief.paragraphs.map((text) => <p key={text}>{text}</p>)}
            </div>
          </div>
        </section>

        <section className="d2-about d2-wrap" id="about" aria-labelledby="d2-about-title">
          <div className="d2-portrait">
            <img src={headshot} alt={about.alt} width="420" height="420" loading="lazy" />
          </div>
          <div>
            <p className="d2-kicker">Who you’ll work with · {about.name}, {about.role}</p>
            <h2 id="d2-about-title">{about.title}</h2>
            {about.paragraphs.map((text) => <p key={text} className="d2-copy">{text}</p>)}
            <a className="d2-inline" href="#contact">{about.cta} →</a>
          </div>
        </section>

        <section className="d2-contact" id="contact" aria-labelledby="d2-contact-title">
          <div className="d2-night">
            <div className="d2-moon" aria-hidden="true" />
            <div className="d2-wrap d2-contact-title">
              <h2 id="d2-contact-title">What would <em>simplicity</em> feel like?</h2>
            </div>
          </div>
          <div className="d2-wrap d2-contact-row">
            <p>{contact.lines.map((line) => <span key={line}>{line}<br /></span>)}</p>
            <a className="d2-email" href={email}>{emailText}</a>
          </div>
        </section>
      </main>

      <footer className="d2-footer d2-wrap">
        <a className="d2-brand" href="#top">bit haiku</a>
        <span>© {year} Bit Haiku LLC</span>
        <div>{socials.map((s) => <a key={s.label} href={s.href} target="_blank" rel="noreferrer">{s.label}</a>)}</div>
      </footer>
      <Switcher current={2} />
    </div>
  );
}
